export default {
  generic_error: 'Jotain meni pieleen',
  address_not_found:
    'Valitettavasti emme löytäneet kyseistä osoitetta. Yritä uudelleen kirjoittamalla ensin katu osoitehakukenttään.',
  internal_error:
    'Valitettavasti tilauksessasi ilmeni odottamaton ongelma, tekninen tiimimme työskentelee jo asian parissa 🛠️.',
};
